// ----------------------
// <auto-generated>
// Generated using the script apiGenerator.js
// </auto-generated>
// -----------------------
import { configuration } from 'config/constants';
import {
    AppContextsClient,
    HealthClient,
    ThirdPartiesClient,
    VendorsClient,
} from './ThirdPartiesApiClient';
import { http } from 'services/ApiService/Http';

const { baseApiUrls: { thirdParties: baseApiUrl } } = configuration;

export const AppContextsApi = new AppContextsClient(baseApiUrl, http);
export const HealthApi = new HealthClient(baseApiUrl, http);
export const ThirdPartiesApi = new ThirdPartiesClient(baseApiUrl, http);
export const VendorsApi = new VendorsClient(baseApiUrl, http);
